import * as React from 'react';
import { NumericFormat, type NumericFormatProps } from 'react-number-format';
import { cn } from '@/lib/utils';

type NumberInputProps = Omit<NumericFormatProps, 'onValueChange'> & {
  onValueChange?: (value: number | undefined) => void;
};

const NumberInput = React.forwardRef<HTMLInputElement, NumberInputProps>(
  ({ className, onValueChange, ...props }, ref) => {
    return (
      <NumericFormat
        getInputRef={ref}
        thousandSeparator=","
        decimalSeparator="."
        allowNegative={false}
        className={cn(
          'flex h-8 w-full border border-border bg-background px-2.5 py-1.5 text-sm tabular-nums',
          'placeholder:text-muted-foreground/60',
          'focus:outline-none focus:border-foreground focus:ring-1 focus:ring-foreground/20',
          'disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-muted',
          className
        )}
        onValueChange={(values) => {
          onValueChange?.(values.floatValue);
        }}
        {...props}
      />
    );
  }
);
NumberInput.displayName = 'NumberInput';

export { NumberInput };
export type { NumberInputProps };
